import { parseTime } from "@/assets/js/Export/setMethods"
import { json2excel } from "@/assets/js/Export/setMethods.js"

import costColumnsJson from '@/components/Order/json/cost.js'
import incomeColumnsJson from '@/components/Order/json/income.js'
import orderMcnColumsJson from '@/components/Order/json/orderMcn.js'
import totalColumsJson from '@/components/Order/json/total.js'
import offlineColumsJson from '@/components/Order/json/offline.js'
import incompleteColumsJson from '@/components/Order/json/incomplete.js'

export function exportOrder ({source,dataList,name}) {
    var userInfo = JSON.parse(localStorage.getItem('userInfo'))
    var dataList = JSON.parse(JSON.stringify(dataList))
    var excelDatas = [];
    if(source == 'cost' || source == 'orderMcn' || source == 'negative' || source == 'offline' || source == 'all' || source == 'income'){
        var tHeader = [],filterVal=[];
        dataList.forEach((item)=>{
            for(var i in item){
                if(i.indexOf('ID') == -1 && i.indexOf('_id') == -1){
                    if(item[i] != '' && item[i] != null){
                        if(!isNaN(item[i])){
                            item[i] = Number(item[i])
                        }
                    }else{
                        item[i] = null
                    }
                }
                if(i.indexOf('date') != -1){
                    if(item[i]&&item[i]!=''){
                        item[i] = new Date(item[i])
                    }
                }
            }
        })
        if(source == 'cost'){
            costColumnsJson.forEach((item,index) => {
                tHeader.push(item.label)
                filterVal.push(item.prop)
            });
        }
        if(source == 'orderMcn'){
            orderMcnColumsJson.forEach((item,index) => {
                tHeader.push(item.label)
                filterVal.push(item.prop)
            });
        }
        if(source == 'negative' || source == 'all'){
            totalColumsJson.forEach((item,index) => {
                tHeader.push(item.label)
                filterVal.push(item.prop)
            });
        }
        
        // 商务助理 总消耗表
        if(userInfo.admin_id == 53 || userInfo.role_id == 12 || userInfo.role_id == 10 
            || userInfo.role_id == 15 || userInfo.role_id == 18){
            if(source == 'all'){
                tHeader = tHeader.concat(['回款日期', '机构回款日期']);
                filterVal = filterVal.concat(['collection_date', 'mcn_collection_date'])                
            }
        }
        //财务 记账数据 多加字段
        if(this.$route.path=='/backupList'){
            if(source == 'all'){
                tHeader = tHeader.concat(['是否提交修改后开票']);
                filterVal = filterVal.concat(['is_edit_invoiced'])
            }
        }
        if(source == 'offline'){
            offlineColumsJson.forEach((item,index) => {
                tHeader.push(item.label)
                filterVal.push(item.prop)
            });
        }
        if(source == 'income'){
            incomeColumnsJson.forEach((item,index) => {
                tHeader.push(item.label)
                filterVal.push(item.prop)
            });
        }
        excelDatas = [
            {
                tHeader: tHeader, // sheet表一头部
                filterVal: filterVal, // 表一的数据字段
                tableDatas: dataList, // 表一的整体json数据
                sheetName: name// 表一的sheet名字
              },
        ]
    }
    if(source == 'incomplete'){
        var tHeader1 = [],filterVal1=[],tHeader2 = [],filterVal2=[];
        if(dataList&&dataList.no_cost_order){
            dataList.no_cost_order.forEach((item)=>{
                for(var i in item){
                    if(i.indexOf('ID') == -1 && i.indexOf('id') == -1){
                        if(item[i] != '' && item[i] != null){
                            if(!isNaN(item[i])){
                                item[i] = Number(item[i])
                            }
                        }else{
                            item[i] = null
                        }
                    }
                    if(i.indexOf('date') != -1){
                        if(item[i]&&item[i]!=''){
                            item[i] = new Date(item[i])
                        }
                    }
                }
            })
        }
        if(dataList&&dataList.no_income_order){
            dataList.no_income_order.forEach((item)=>{
                for(var i in item){
                    if(i.indexOf('ID') == -1 && i.indexOf('id') == -1){
                        if(item[i] != '' && item[i] != null){
                            if(!isNaN(item[i])){
                                item[i] = Number(item[i])
                            }
                        }else{
                            item[i] = null
                        }
                    }
                    if(i.indexOf('date') != -1){
                        if(item[i]&&item[i]!=''){
                            item[i] = new Date(item[i])
                        }
                    }
                }
            })
        }
        costColumnsJson.forEach((item,index) => {
            tHeader1.push(item.label)
            filterVal1.push(item.prop)
        });
        incompleteColumsJson.forEach((item,index) => {
            tHeader2.push(item.label)
            filterVal2.push(item.prop)
        });
        excelDatas = [
            {
                tHeader: tHeader1, // sheet表一头部
                filterVal: filterVal1, // 表一的数据字段
                tableDatas: dataList.no_cost_order, // 表一的整体json数据
                sheetName: '成本与返点残缺表'// 表一的sheet名字
            },
            {
                tHeader: tHeader2,
                filterVal: filterVal2,
                tableDatas: dataList.no_income_order,
                sheetName: '收入残缺表'
            }
        ]
    }
    json2excel(excelDatas, name, true, "xlsx")//   引入的函数
}


// WEBPACK FOOTER //
// ./src/assets/js/Export/index.js